var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "el-dialog1",
          staticStyle: {
            "margin-left": "52%",
            overflow: "inherit",
            top: "-1.6rem !important",
          },
          attrs: { visible: _vm.dialogVisible, width: "98%" },
          on: {
            close: _vm.close,
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.current !== "抬头纸上传"
            ? _c(
                "div",
                { staticClass: "title" },
                _vm._l(_vm.swithBtn, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "btns",
                      class: item === _vm.current ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.handlerSwithClick(item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item) + " ")]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.current === "抬头纸上传"
            ? _c("div", { staticClass: "container1" }, [
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c("p", { staticClass: "p1" }, [
                      _vm._v("点击此处上传您的抬头纸页眉"),
                    ]),
                    _c("ResourceUpload", {
                      ref: "upload",
                      attrs: {
                        parentId: String(_vm.parentId),
                        showFlodNames: ["抬头纸页眉"],
                        ossRoute: "companyImage",
                        fileLimit: 1,
                        flodName: "抬头纸页眉",
                        listType: "picture-card",
                      },
                      model: {
                        value: _vm.picList,
                        callback: function ($$v) {
                          _vm.picList = $$v
                        },
                        expression: "picList",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _c("p", { staticClass: "p1" }, [
                      _vm._v("点击此处上传您的抬头纸页脚"),
                    ]),
                    _c("ResourceUpload", {
                      ref: "upload1",
                      attrs: {
                        parentId: String(_vm.parentId),
                        showFlodNames: ["抬头纸页脚"],
                        ossRoute: "companyImage",
                        fileLimit: 1,
                        flodName: "抬头纸页脚",
                        listType: "picture-card",
                      },
                      model: {
                        value: _vm.picList1,
                        callback: function ($$v) {
                          _vm.picList1 = $$v
                        },
                        expression: "picList1",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                { staticClass: "container2" },
                [
                  _c("p", { staticClass: "p1" }, [
                    _vm._v(
                      " 请维护您在方案后会带出的共性内容 (前端word导出后，及小程序导出前可修改) "
                    ),
                  ]),
                  _c("div", { staticClass: "p2" }, [
                    _vm._v(" 报价说明版本: "),
                    _c("span", { staticClass: "span1" }, [
                      _vm._v("（点击名称查看展示效果)"),
                    ]),
                    _c(
                      "p",
                      {
                        staticClass: "p3",
                        on: {
                          click: function ($event) {
                            return _vm.handlerAddClick()
                          },
                        },
                      },
                      [_vm._v("新增")]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "priceSm" },
                    _vm._l(_vm.schemeList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "priceSmText" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "p4",
                              class: _vm.datas.id === item.id ? "active2" : "",
                              on: {
                                click: function ($event) {
                                  return _vm.handlerSelectClick(item, "hu")
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.schemeName) + " ")]
                          ),
                          _c("svg-icon", {
                            staticClass: "svg",
                            attrs: { iconClass: "edit" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerSelectClick(item, "hu")
                              },
                            },
                          }),
                          _c("svg-icon", {
                            staticClass: "svg",
                            attrs: { iconClass: "delete" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDeleteClick(item)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c("el-card", { staticClass: "box-card" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "max-height": "5.9rem",
                          "overflow-y": "scroll",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "line1" },
                          [
                            _c("p", { staticClass: "p5" }, [
                              _vm._v("报价说明 版本名称"),
                            ]),
                            _c("el-input", {
                              attrs: {
                                size: "small",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.datas.schemeName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.datas, "schemeName", $$v)
                                },
                                expression: "datas.schemeName",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._l(_vm.btnsList, function (item, keys) {
                          return _c(
                            "div",
                            { key: keys, staticClass: "line1" },
                            [
                              _c(
                                "div",
                                { staticClass: "left" },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass: "p5",
                                      staticStyle: { width: "1.5rem" },
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                  item.flag
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "btns",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlerAddBtnsClick(
                                                keys,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "red",
                                                "margin-right": "0.05rem",
                                              },
                                            },
                                            [_vm._v("+")]
                                          ),
                                          _c("span", [_vm._v("加项")]),
                                        ]
                                      )
                                    : _c("el-input", {
                                        staticStyle: { width: "1.2rem" },
                                        attrs: { size: "medium" },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.inputBlue(item, keys)
                                          },
                                        },
                                        model: {
                                          value: _vm.addValue,
                                          callback: function ($$v) {
                                            _vm.addValue = $$v
                                          },
                                          expression: "addValue",
                                        },
                                      }),
                                ],
                                1
                              ),
                              _c(
                                "draggable",
                                {
                                  staticClass: "right",
                                  attrs: { group: "btns", animation: "300" },
                                  on: {
                                    add: _vm.addChange,
                                    start: function ($event) {
                                      return _vm.onStart($event, keys)
                                    },
                                    end: function ($event) {
                                      return _vm.onEnd($event, keys)
                                    },
                                  },
                                  model: {
                                    value: item.arr,
                                    callback: function ($$v) {
                                      _vm.$set(item, "arr", $$v)
                                    },
                                    expression: "item.arr",
                                  },
                                },
                                _vm._l(item.arr, function (item1, index1) {
                                  return _c("div", { key: index1 }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "btns",
                                        class:
                                          _vm.selectDatas.budgetTitle ===
                                            item1.budgetTitle &&
                                          _vm.selectDatas.budgetDescType == keys
                                            ? "active1"
                                            : "",
                                        on: {
                                          contextmenu: function ($event) {
                                            $event.preventDefault()
                                            $event.stopPropagation()
                                            return _vm.rightClick(item1)
                                          },
                                          click: function ($event) {
                                            return _vm.handlerSelectBtnClick(
                                              item1
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item1.budgetTitle) + " "
                                        ),
                                        item1.budgetTitleContent.length > 0
                                          ? _c("img", {
                                              staticClass: "checkIcon",
                                              attrs: {
                                                src: require("@/assets/png/btnRight.png"),
                                                alt: "",
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ])
                                }),
                                0
                              ),
                            ],
                            1
                          )
                        }),
                        _c("div", { staticClass: "line" }),
                        _c("div", { staticClass: "centerBox" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "0.24rem" } },
                            [
                              _vm.isShow
                                ? _c("Ueditor", {
                                    ref: "ueditor",
                                    staticClass: "myUeditor",
                                    attrs: { parentId: _vm.datas.id },
                                    on: { ueditorChange: _vm.ueditorChange },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      { staticClass: "footerBottomBtns" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "bnts1",
                            attrs: { plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerSelectClick(_vm.datas)
                              },
                            },
                          },
                          [_vm._v("查看效果")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "btns2",
                            attrs: { plain: "" },
                            on: { click: _vm.save },
                          },
                          [_vm._v("提交")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "btns2",
                            attrs: { plain: "" },
                            on: {
                              click: function ($event) {
                                _vm.dialogVisible = false
                              },
                            },
                          },
                          [_vm._v("取消编辑")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
        ]
      ),
      _c("offerDetailPopup", { ref: "offerDetailPopup" }),
      _c("modifyChild", { ref: "modifyChild", on: { update: _vm.update } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }